import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import { ACCOUNT, SETTING, BOOKINGCALENDAR, HOLIDAY } from '../../reduxs'
import { StyleSidebar } from './style'
import { SmallCalendar } from '../../components'
import { IMG, getFontContrastColor } from '../../themes'

import {
  routePath,
  ROUTE,
  removeLocalStorage,
  removeSessionStorage,
  TEXT_ENCRYPT,
  cutString2,
} from '../../helpers'
import ReactGA from "react-ga"
import { unregisterServiceWorker } from '../../configs'

export class Sidebar extends Component {

  constructor(props) {
    super(props)
    this.state = {
      date: this.props.date,
      month: this.props.month,
      year: this.props.year,
      setDefaultTheme: true,
      image: undefined,
      monthChange: 0,
    }
    //GA TrackingId
    ReactGA.initialize("UA-153387162-1")

    this.sideMenuRef = React.createRef()

    this.service()
  }

  componentDidMount () {
    const {
      month,
      year,
      bookingcalendarAction,
      accountReducer,
    } = this.props
    const { userId, username } = accountReducer.user

    bookingcalendarAction.getAllListEventSideBar({
      userId,
      username,
      month,
      year,
      status: '[0,1,2]'
    })

    localStorage.removeItem('smallCalendarMonth')
  }

  componentDidUpdate (prevProps) {
    const {
      month,
      year,
      bookingcalendarAction,
      accountReducer,
    } = this.props
    const { userId, username } = accountReducer.user

    if (prevProps.year !== year) {
      bookingcalendarAction.clearAllListEventSideBar()
      bookingcalendarAction.getAllListEventSideBar({
        userId,
        username,
        month,
        year,
        status: '[0,1,2]'
      })
    }
  }

  handleGetHolidayList = (month, year) => {
    const { companyId } = this.props.accountReducer.user

    const date = new Date(year, month)
    const dateEndOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
    const startDatetimeGetHoliday = moment(date).format('YYYY-MM-01 00:00:00')
    const endDatetimeGetHoliday = moment(date).format(`YYYY-MM-${dateEndOfMonth} 23:59:59`)

    this.props.getSidebarHolidays({
      startDatetime: startDatetimeGetHoliday,
      endDatetime: endDatetimeGetHoliday,
      companyId,
      limit: 31,
      isSideBar: true,
    })
  }

  setMonthChange = (month) => {
    this.setState({ monthChange: month })
  }

  setYearChange = (year) => {
    const { bookingcalendarAction, accountReducer } = this.props
    const { userId, username } = accountReducer.user

    bookingcalendarAction.clearAllListEventSideBar()
    bookingcalendarAction.getAllListEventSideBar({
      userId,
      username,
      year,
      status: '[0,1,2]'
    })
  }

  service () {
    const { accountAction } = this.props
    accountAction.getProfile({}, () => {
      const { accountReducer } = this.props
      this.setState({
        image: accountReducer.profile ? accountReducer.profile.imageBase64 ? `data:jpg;base64,` + accountReducer.profile.imageBase64 : undefined : undefined,
      })
    })
  }

  changeCalendar = ({
    selectDate,
    selectMonth,
    selectYear
  }) => {
    this.setState({
      date: selectDate,
      month: selectMonth + 1,
      year: selectYear,
    }, () => {
      const { location, history } = this.props

      if (location.pathname.startsWith('/calendar/month/')) {
        history.push(`/calendar/month/${selectYear}/${selectMonth + 1}/${selectDate}`)
      } else {
        this.logicChangePath(location.pathname)
      }
    })
  }

  logicChangePath = (path) => {
    const { history, match, location } = this.props
    const roomID = match.params.roomId
    const key = ROUTE.CALENDAR.LINK

    // Initialize date, month, and year using the state
    let { date, month, year } = this.state

    // Check if the current route is a calendar route
    if (location.pathname.startsWith('/calendar/month/')) {
      const parts = location.pathname.split('/')

      // Extract and update date, month, and year
      date = parseInt(parts[5])
      month = parseInt(parts[4])
      year = parseInt(parts[3])

      // Update the state with the new values
      this.setState({ date, month, year })
    }

    if (path.includes(ROUTE.FLOORPLAN.CALENDAR)) {
      path = `${ROUTE.FLOORPLAN.CALENDAR}/${roomID}/${year}/${month}/${date}`
    } else if (path.split('/')[1].toLowerCase() === key.toLowerCase() || path.includes(key)) {
      const view = match.params.view ? match.params.view : 'month'
      path = `${key}/${view}/${year}/${month}/${date}`
    } else if (path === ROUTE.MEETING_ROOM.LIST || path.includes(ROUTE.MEETING_ROOM.DETAIL)) {
      path = `${path}?date=${year}/${month}/${date}`
    } else if (path.startsWith(ROUTE.BOOKING.LINK)) {
      const searchParams = new URLSearchParams(location.search)
      searchParams.set('date', `${year}/${month}/${date}`)
      path = `${location.pathname}?${searchParams.toString().replace(/%2F/g, '/')}`
    } else if (path === ROUTE.USER_SETTING.LINK) {
      path = `${path}?date=${year}/${month}/${date}`
    } else {
      const currentPath = path.split('/')
      let index = 0
      for (const _path of currentPath) {
        if (_path && !isNaN(_path)) {
          index++
          break
        }
      }
      if (index > 0) {
        path = `${currentPath.slice(0, currentPath.length - 3).join('/')}/${year}/${month}/${date}`
      } else {
        path = `/${currentPath[1]}/${year}/${month}/${date}`
      }
    }
    const basePath = path.split('?')[0]
    if (basePath === location.pathname && !basePath.includes(ROUTE.MEETING_ROOM.DETAIL)) {
      history.replace(path)
    } else {
      history.push(path)
    }
  }

  renderMenu = () => {
    const { location, accountReducer, settingReducer } = this.props
    const { colorTheme } = settingReducer.settingTheme
    let menus = routePath()

    return (
      <div className='sidebar-menu-sections'>
        {menus.map((res, index) => {
            let pathname = location.pathname.split('/')
            let link = res.LINK.split('/')
            let isActive = pathname[1] === link[1] ? 'active-' : ''
  
            if (pathname[1] === 'booking' || pathname[1] === 'meeting-info') {
              const searchParams = new URLSearchParams(location.search)
              const fromParam = searchParams.get('from')
            
            if (fromParam && fromParam.includes('meetingroom') && link[1] === 'meetingroom') {
              isActive = 'active-'
            } else if (fromParam && fromParam.includes('floorplan') && link[1] === 'floorplan') {
              isActive = 'active-'
            } else if (fromParam && fromParam.includes('calendar') && link[1] === 'calendar') {
              isActive = 'active-'
            } else if (!fromParam && link[1] === 'calendar') {
              isActive = 'active-'
            }
          }

          let displayMenu = ''
          if (accountReducer.permission.includes(res.CODE)) {
            displayMenu = (
              <div
                className='sidebar-menu'
                key={index}
                style={{
                  ...(isActive && {
                    backgroundColor: colorTheme,
                    color: getFontContrastColor(colorTheme),
                  }),
                }}
                onClick={() => this.logicChangePath(res.LINK)}
              >
                {res[accountReducer.language]}
              </div>
            )
          }

          return displayMenu
        })}
      </div>
    )
  }

  logout = () => {
    const {
      accountAction,
      history
    } = this.props
    this.setState({
      open: false
    }, async () => {
      accountAction.clearAllData()

      removeSessionStorage(TEXT_ENCRYPT.ACCOUNT)
      removeSessionStorage(TEXT_ENCRYPT.PASS)
      removeSessionStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
      removeSessionStorage(TEXT_ENCRYPT.IS_REGISTER_FIREBASE)

      removeLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
      removeLocalStorage(TEXT_ENCRYPT.IS_REGISTER_FIREBASE)

      history.push(ROUTE.LOGIN.LINK)
      try {
        await unregisterServiceWorker()
      } catch {
        console.error('unregisterServiceWorker error')
      }
    })
    this.trackingLogoutButton()
  }

  trackingLogoutButton () {
    ReactGA.event({
      category: "Side Bar",
      action: "Logout_Button",
    })
  }

  render () {
    const { date, month, year } = this.props
    const { image, monthChange } = this.state
    const dateNew = new Date(year, month - 1, date)
    const { accountReducer, settingReducer, bookingcalendarReducer } = this.props
    const { allListEventSideBar } = bookingcalendarReducer

    const { isDefaultLogo, logoId, colorTheme } = settingReducer.settingTheme
    let logoTheme = ''
    if (isDefaultLogo === 0 && logoId) {
      logoTheme = `${process.env.REACT_APP_BASE_API_URL}file/image/${logoId}`
    } else {
      logoTheme = IMG['vichai_logo.svg']
    }

    let markDay = []
    let list = []
    for (let i in allListEventSideBar) {
      list.push([allListEventSideBar[i]])
    }

    list.forEach((month, index) => {
      month.forEach((listDay) => {
        listDay.forEach((date) => {
          markDay.push({
            month: index,
            date
          })
        })
      })
    })

    let dateMark = []
    if (monthChange === month) {
      if (markDay.filter((item) => item.month !== 0).length === 0) {
        dateMark = markDay.filter((item) => item.month === 0).map((item) => item.date)
      } else {
        dateMark = markDay.filter((item) => item.month === month).map((item) => item.date)
      }
    } else {
      if (markDay.filter((item) => item.month !== 0).length === 0) {
        dateMark = markDay.filter((item) => item.month === 0).map((item) => item.date)
      } else {
        dateMark = markDay.filter((item) => item.month === monthChange).map((item) => item.date)
      }
    }

    return (
      <StyleSidebar>
        <div className='body'>
          <div className='body-top'>
            <div className='header-title'>
              <img className='img-width' src={logoTheme} alt='logo' />
            </div>

            {this.renderMenu()}

            <div className='small-calendar'>
              <SmallCalendar
                {...this.props}
                isShowing={true}
                selectDate={dateNew}
                startSelectable={dateNew}
                tempDate={dateNew}
                language={accountReducer.language}
                pathChange={this.changeCalendar}
                showArrow={true}
                dateMark={dateMark}
                setMonthChange={this.setMonthChange}
                setYearChange={this.setYearChange}
                isSideBar={true}
                handleGetHoliday={this.handleGetHolidayList}
                isNav={true}
              />
            </div>
          </div>
          <div className='body-bottom'>

            <div className='profile'>
              {image ? (
                <img src={image} className='pointer avatar' alt='' />
              ) : (
                <div 
                  className='pointer avatar-placeholder' 
                  style={{ backgroundColor: colorTheme }}
                >
                  {accountReducer.user.username.charAt(0).toUpperCase()}
                </div>
              )}
              <span className='profile-email'>{cutString2(accountReducer.user.username, 16)}</span>
              <img
                src={IMG['ic_logout.svg']}
                className='pointer logout-icon'
                onClick={this.logout}
                alt=''
              />
            </div>
          </div>
        </div>
      </StyleSidebar>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    accountAction: bindActionCreators(ACCOUNT.action, dispatch),
    settingAction: bindActionCreators(SETTING.action, dispatch),
    bookingcalendarAction: bindActionCreators(BOOKINGCALENDAR.action, dispatch),
    getSidebarHolidays: (params) => dispatch(HOLIDAY.action.getSidebarHolidays(params)),
  }
}

export const mapStateToProps = ({
  accountReducer,
  loaderReducer,
  holidayReducer,
  settingReducer,
  bookingcalendarReducer,
}) => {
  return {
    accountReducer,
    loaderReducer,
    holidayReducer,
    settingReducer,
    bookingcalendarReducer,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar)
